import {
  Input as UIKitInput,
  InputProps as UIKitInputProps,
} from "@pepperstone/pepper-ui-kit";

import { FieldError } from "../FieldError";

export type InputProps = Pick<
  UIKitInputProps,
  | "name"
  | "label"
  | "value"
  | "onChange"
  | "disabled"
  | "type"
  | "inputMode"
  | "maxLength"
> & {
  error?: string;
};

export const Input = ({
  name,
  label,
  value,
  onChange,
  disabled,
  type = "text",
  error,
  maxLength,
}: InputProps) => (
  <div className="flex flex-col gap-2">
    <UIKitInput
      id={name}
      label={label}
      name={name}
      labelFor={name}
      disabled={disabled}
      type={type}
      value={value}
      onChange={onChange}
      className="!bg-gray-100 !outline-1 !outline-gray-200 [&_input]:!outline-0"
      maxLength={maxLength}
    />
    {error && <FieldError text={error} />}
  </div>
);
